<div class="loading-bar" [class.active]="active()">
  <div class="loading-bar__fill" [style.width.%]="progress()"></div>
</div>
